// extracted by mini-css-extract-plugin
module.exports = {"broadcastStatusBadge":"style_broadcastStatusBadge__35R98","sizeBig":"style_sizeBig__1DLVI","live":"style_live__1kp0W","past":"style_past__W0FD3","future":"style_future__2085j"};